import { Reducer } from 'redux';

import { ThunkSuccessAction, ThunkFailAction } from '../../services/apiMiddleware';

import { DeleteCompany } from './actionTypes';

export interface CompanySettingsState {
  loadingDelete: boolean;
}

export function getInitialCompanySettingsState(): CompanySettingsState {
  return {
    loadingDelete: false,
  };
}

const companySettingsReducer: Reducer<CompanySettingsState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialCompanySettingsState(),
  action,
) => {
  switch (action.type) {
    case DeleteCompany.Request:
      return { ...state, loadingDelete: true };

    case DeleteCompany.Success:
      return { ...state, loadingDelete: false };

    case DeleteCompany.Failed:
      return { ...state, loadingDelete: false };

    default:
      return state;
  }
};

export default companySettingsReducer;
